import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../api/client';

/**
 * A bot állapota és a launcher verziója — egyszer kérjük le, a Licence & launcher fül innen olvassa.
 *
 *   GET /api/owner/status      → { status: 'working' | 'updating' }
 *   GET /api/launcher/version  → { version }   (2026-10-21 óta; előtte a loaderé)
 *
 * A bot oldalán minden kérés belépést kér, ezért csak bejelentkezve töltünk (a hívó csak akkor teszi ki).
 * Hiba esetén a `status` 'unknown' marad: inkább semmit nem mond, mint rosszat.
 */
const SiteStatusContext = createContext({ status: 'unknown', launcherVersion: null });

export function SiteStatusProvider({ children }) {
  const [status, setStatus] = useState('unknown');
  const [launcherVersion, setLauncherVersion] = useState(null);

  useEffect(() => {
    api.get('/owner/status')
      .then(res => setStatus(res.data?.status === 'updating' ? 'updating' : 'working'))
      .catch(() => setStatus('unknown'));
    api.get('/launcher/version')
      .then(res => setLauncherVersion(res.data?.version || null))
      .catch(() => setLauncherVersion(null));
  }, []);

  return (
    <SiteStatusContext.Provider value={{ status, launcherVersion }}>
      {children}
    </SiteStatusContext.Provider>
  );
}

export const useSiteStatus = () => useContext(SiteStatusContext);
